import { Auth0Provider } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";

export const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_AUTH0_CALLBACK_URL;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState, user) => {
    const namespace = "https://createwithabi.ca/";
    const roles =
      user && user[namespace + "roles"] ? user[namespace + "roles"] : [];

    const isDealer = roles.includes("dealer") || roles.includes("Dealer");
    const isAdmin = roles.includes("admin") || roles.includes("Admin");
    const redirectTo = isDealer
      ? "/dealer"
      : isAdmin
      ? "/admin"
      : "/restricted";
    navigate(redirectTo);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
